<template>
  <div class="pb-5">
    <nav-bar/>
    <sidebar-toggle-button/>
    <chat-page/>
    <ticket-button/>
    
    <!-- Sidebar -->
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
        <li class="nav-item">
          <span class="nav-link navbar-text pull-left" @click="current = 'addressBook'" :class="{'current': current === 'addressBook'}">
            {{$t('AddressBook.sidebar.address_book')}}
          </span>
        </li>
        <li class="nav-item" v-if="$store.state.userInfo && $store.state.userInfo.isSageOne">
          <span class="nav-link navbar-text pull-left" @click="current = 'sageOne'" :class="{'current': current === 'sageOne'}">
            {{$t('AddressBook.sidebar.sageone')}}
          </span>
        </li>
        <li class="nav-item" v-if="$store.state.userInfo && $store.state.userInfo.isSageOne">
          <span class="nav-link navbar-text pull-left" @click="current = 'linkTrans'" :class="{'current': current === 'linkTrans'}">
            {{$t('AddressBook.sidebar.linkTrans')}}
          </span>
        </li>
        <li class="nav-item" v-if="$store.state.userInfo && $store.state.userInfo.isSageOne">
          <span class="nav-link navbar-text pull-left" @click="current = 'linkDeal'" :class="{'current': current === 'linkDeal'}">
            {{$t('AddressBook.sidebar.linkDeal')}}
          </span>
        </li>
        <button id="addCustomer" class="btn btn-kne-orange col-12 mt-3" @click="add = true; clear(); setModalTitle($t('AddressBook.addTitle'))">
          <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>
          {{$t('AddressBook.sidebar.add')}}
        </button>

        <custom-json-excel
          class="mt-2"
          :customerFields="customers_fields"
          :filterResults="customers"
          :name="'addressBook.xls'"
        />
      </ul>
    </div>
    
    <!-- Addressbook -->
    <table-element
      v-if="current === 'addressBook'"
      :isShowFilter="true"
      :title="$t('AddressBook.title')"
      :fields="fieldsObjADR"
      :arrOfElement="customers"
      :sortSpacing="0"
      :isShowSelectAll="false"
      class="card mx-2 my-5"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(customer, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <td class="nowrap"><p class="table-fix-width">{{customer.name || '-'}}</p></td>
          <td class="nowrap">{{customer.address || '-'}}</td>
          <td class="nowrap">{{customer.phone || '-'}}</td>
          <td class="nowrap">{{customer.fax || '-'}}</td>
          <td class="nowrap">{{customer.email || '-'}}</td>
          <td class="nowrap">{{customer.contact || '-'}}</td>
          <td>
            <input @click.prevent="modifying(customer); setModalTitle($t('AddressBook.modifyTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
          </td>
        </tr>
      </template>
      
      <template #body-content-mobile="content">
        <div class="card my-2 mx-2" v-for="customer in content.results" :key="customer['.key']">
          <div class="card-header m-2">
            <h4>{{customer.name}}</h4>
            <h6><i class="fa fa-phone"></i>{{customer.phone || '-'}}</h6>
            <h6><i class="fa fa-envelope"></i>{{customer.email || '-'}}</h6>
          </div>
          <div class="m-2">
            <h6><i class="fa fa-home"></i>{{customer.address || '-'}}</h6>
            <h6><i class="fa fa-fax"></i>{{customer.fax || '-'}}</h6>
            <h6><i class="fa fa-address-book"></i>{{customer.contact || '-'}}</h6>
            <div id="action">
              <input @click.prevent="modifying(customer); setModalTitle($t('AddressBook.modifyTitle'))" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modify')">
            </div>
          </div>
        </div>
      </template>
    </table-element>
    
    <!-- Sage One -->
    <table-element
      v-if="current === 'sageOne'"
      :isShowFilter="true"
      :title="$t('AddressBook.title_sageOne')"
      :fields="fieldsObjSAG"
      :arrOfElement="sageone"
      :sortSpacing="0"
      class="card mx-2 my-5"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
        <a class="btn btn-sm btn-kne-orange pull-right" target="_blank" :href="'https://mysageone.ca.sageone.com/oauth2/auth?response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/sageone/SageoneToken&scope=full_access&transpuid='">
          <i class="fa fa-refresh" aria-hidden="true"></i>
        </a>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(customer, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <td class="nowrap">{{customer.A || customer.name}}</td>
          <td>
            <input @click.prevent="modifyingSage(customer)" type="button" class="btn btn-kne-orange pull-right w-100" :value="$t('AddressBook.modify')">
          </td>
        </tr>
      </template>
      
      <template #body-content-mobile="content">
        <!-- List of orders -->
        <div v-for="(customer, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <h6 class="nowrap">{{customer.A || customer.name}}</h6>
          <div>
            <input @click.prevent="modifyingSage(customer)" type="button" class="btn btn-kne-orange pull-right w-100" :value="$t('AddressBook.modify')">
          </div>
        </div>
      </template>
    </table-element>

    <!-- Link Transporter -->
    <table-element
      v-if="current === 'linkTrans'"
      :isShowFilter="true"
      :title="$t('AddressBook.title_transporter')"
      :fields="fieldsObjTRA"
      :arrOfElement="trans"
      :sortSpacing="0"
      class="card mx-2 my-5"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(transporter, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <td class="nowrap">{{transporter.name}}</td>
          <td>
            <input @click.prevent="modifyingTransDealSage(transporter, 'transporter')" type="button" class="btn btn-kne-orange pull-right w-100" :value="$t('AddressBook.modify')">
          </td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <div v-for="(transporter, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <h6 class="nowrap">{{transporter.name}}</h6>
          <div>
            <input @click.prevent="modifyingTransDealSage(transporter, 'transporter')" type="button" class="btn btn-kne-orange pull-right w-100" :value="$t('AddressBook.modify')">
          </div>
        </div>
      </template>
    </table-element>
    
    <!-- Link Dealer -->
    <table-element
      v-if="current === 'linkDeal'"
      :isShowFilter="true"
      :title="$t('AddressBook.title_dealer')"
      :fields="fieldsObjDEA"
      :arrOfElement="deal"
      :sortSpacing="0"
      class="card mx-2 my-5"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(dealer, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <td class="pt-2 nowrap">{{dealer.name}}</td>
          <td>
            <input @click.prevent="modifyingTransDealSage(dealer, 'dealer')" type="button" class="btn btn-kne-orange pull-right w-100" :value="$t('AddressBook.modify')">
          </td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <div v-for="(dealer, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <h6 class="pt-2 nowrap">{{dealer.name}}</h6>
          <div>
            <input @click.prevent="modifyingTransDealSage(dealer, 'dealer')" type="button" class="btn btn-kne-orange pull-right w-100" :value="$t('AddressBook.modify')">
          </div>
        </div>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

    <!-- Modals -->
    <transition name="fade">
      
      <!-- Modify Sage -->
      <modal
        :title="$t('AddressBook.sageone_change_title')"
        v-if="modifySage"
        @close-request="modifySage = false"
        
        closable
      >
        <!-- <h3>{{$t('AddressBook.sageone_change_title')}}</h3> -->
        <div class="col-12">{{sageOneChange.target.A || sageOneChange.target.name}}</div>
        <regular-datalist
          multiSelect
          :value="datalist.name"
          @input="setSage($event)"
          :secondList="customers"
          :thirdList="dealerTrans"
          class="col-12 form-group datalist"/>
        <transition-group tag="div" name="fade" id="multi" class="container-fluid">
          <span v-if="customer.key" v-for="(customer, index) in sageCustomer" class="badge badge-kne mr-2" :key="customer.key">
            {{customer.value}}
            <i @click="sageCustomer.splice(index, 1)" class="fa fa-times fa-lg p-1 delete" aria-hidden="true"></i>
          </span>
        </transition-group>
        <div class="col-12 mt-3">
          <input :disabled="sageCustomer.length < 1" @click="SubmitmodifySage()" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modifySageSubmit')">
        </div>
      </modal>

      <!-- Modify Sage DealTrans -->
      <modal
        :title="$t('AddressBook.sageone_change_title')"
        v-if="modifySageDealTrans"
        @close-request="modifySageDealTrans = false"
        
        closable
      >
        <div class="col-12">{{sageOneChange.target.name}}</div>
        <regular-datalist
          :value="datalist.name"
          @input="datalist.name = $event.value; datalist.key = $event.key"
          :sageOne="sageone"
          class="col-12 form-group datalist"/>
        <div class="col-12 mt-3">
          <input :disabled="datalist.key === null" @click="SubmitmodifyTransDealSage()" type="button" class="btn btn-kne-orange pull-right" :value="$t('AddressBook.modifySageSubmit')">
        </div>
      </modal>

      <!-- Add and modify -->
      <modal
        :title="modalTitle"
        v-if="add === true || modify === true"
        @close-request="add = false; modify = false"
        
        closable
      >
        <div>
          <div>
            <vue-google-autocomplete
              class="form-control vgaSearch m-3"
              id="map"
              :placeholder="$t('AddressBook.search_autocomplete')"
              v-on:placechanged="getAddressData"
              :country="['ca', 'us']"
              :fields="autocompleteSearchFields"
            >
            </vue-google-autocomplete>
            <regular-input
              :value="customer.name"
              @input="customer.name = $event"
              type="text" :placeholder="$t('AddressBook.name') + '*'" class="col-12 form-group"/>
            <regular-input
              :value="customer.address"
              @input="customer.address = $event"
              :disabled="true"
              type="text" :placeholder="$t('AddressBook.address') + '*'" class="col-12 form-group"/>
            <regular-input
              :value="customer.postcode"
              @input="customer.postcode = $event"
              :disabled="true"
              type="text" :placeholder="$t('AddressBook.postCode') + '*'" class="col-12 form-group"/>
            <regular-input
              :value="customer.city"
              @input="customer.city = $event"
              :disabled="true"
              type="text" :placeholder="$t('AddressBook.city') + '*'" class="col-12 form-group"/>
            <regular-input
              :value="customer.province"
              @change="customer.province = $event"
              :disabled="true"
              :placeholder="$t('AddressBook.province') + '*'" class="col-12 form-group"/>
            <regular-input
              :value="customer.country"
              @change="customer.country = $event"
              :disabled="true"
              :placeholder="$t('AddressBook.country') + '*'" class="col-12 form-group"/>
          </div>

          <regular-input
            :value="customer.phone"
            @input="customer.phone = $event"
            type="text" :placeholder="$t('AddressBook.phone') + '*'" class="col-12 form-group"/>
          <regular-input
            :value="customer.email"
            @input="customer.email = $event"
            type="text" :placeholder="$t('AddressBook.email')" class="col-12 form-group"/>
          <regular-input
            :value="customer.receptionEmail"
            @input="customer.receptionEmail = $event"
            type="text" :placeholder="$t('AddressBook.receptionEmail')" class="col-12 form-group"/>
          <regular-input
            :value="customer.fax"
            @input="customer.fax = $event"
            type="text" :placeholder="$t('AddressBook.fax')" class="col-12 form-group"/>
          <regular-input
            :value="customer.contact"
            @input="customer.contact = $event"
            type="text" :placeholder="$t('AddressBook.contact')" class="col-12 form-group"/>
          <regular-input
            :value="customer.sageID"
            @input="customer.sageID = $event"
            type="text" :disabled="true" :placeholder="$t('AddressBook.sageID')" class="col-12 form-group"/>
          <regular-input
            :value="customer.comments"
            @input="customer.comments = $event"
            type="text" :placeholder="$t('AddressBook.comments')" class="col-12 form-group"/>
        </div>
        <div class="col-12">
          <button v-if="add" class="btn btn-kne-orange w-100 mb-2" :disabled="!customerFilledForm" @click="addCustomer()">{{$t('AddressBook.addSubmit')}}</button>
          <button v-else class="btn btn-kne-orange w-100 mb-2" :disabled="!customerFilledForm" @click="modifyCustomer()">{{$t('AddressBook.modifySubmit')}}</button>
          <button v-if="modify && isAdmin" class="btn btn-danger w-100 mb-2" @click="deleteCustomer()">{{$t('AddressBook.deleteTitle')}}</button>
        </div>
      </modal>

    </transition>

  </div>
</template>

<script>
import Modal from '../module/interface-components/Modal.vue'
import regularInput from '../module/basic-components/regularInput.vue'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import Search from '../module/special-components/Other-components/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'
import JsonExcel from 'vue-json-excel'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import ChatPage from '../module/interface-components/ChatPage.vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import TicketButton from '../module/interface-components/TicketButton.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import CustomJsonExcel from '../module/special-components/Custom-packages/Custom-JsonExcel.vue'

  export default {
    name: 'AddressBook',
    components: {
      Modal,
      regularInput,
      regularCheckbox,
      regularTextarea,
      regularSelect,
      Search,
      JsonExcel,
      SidebarToggleButton,
      ChatPage,
      VueGoogleAutocomplete,
      TicketButton,
      TableElement,
      LoadingRender,
      CustomJsonExcel
    },

    data () {
      return {
        customers_fields: {
          'name': 'name',
          'address': 'address',
          'city': 'city',
          'email': 'email',
          'phone': 'phone',
          'postcode': 'postcode',
          'province': 'province',
          'country': 'country',
          'comments': 'comments',
          'contact': 'contact'
        },
        current: 'addressBook',
        sageOneNameFilter: '',
        sageOneChange: {
          target: {},
          type: ''
        },
        modifySage: false,
        modifySageDealTrans: false,
        datalist: {
          name: '',
          key: null
        },
        sageCustomer: [],
        add: false,
        modify: false,
        key: '',
        customer: {
          name: '',
          address: '',
          phone: '',
          fax: '',
          email: '',
          receptionEmail: '',
          contact: '',
          postcode: '',
          city: '',
          province: '',
          country: '',
          comments: '',
          place_id: '',
          lat: '',
          long: '',
          sageID: ''
        },
        provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
        fields: {
          name: '',
          address: '',
          phone: '',
          fax: '',
          email: '',
          contact: ''
        },
        filterResults: [],
        filterResultsSageOne: [],
        customers: [],
        dealerTrans: [],
        sageone: [],
        paginate: ['filterResults', 'filterResultsSageOne'],
        trans: [],
        deal: [],
        autocompleteSearchFields: ['address_components', 'adr_address', 'alt_id', 'formatted_address', 'formatted_phone_number', 'geometry', 'icon',
         'id', 'name', 'business_status', 'photo', 'place_id', 'scope', 'type', 'url', 'utc_offset_minutes', 'vicinity'],
        searchHistory: [],
        searchType: '',
        searchText: '',
        historyTypeTag: '',
        modalTitle: '', // Title for Add and modify user
        fieldsObjADR: [
          {
            text: this.$t('AddressBook.name'),
            type: 'name',
            value: ''
          },
          {
            text: this.$t('AddressBook.address'),
            type: 'address',
            value: ''
          },
          {
            text: this.$t('AddressBook.phone'),
            type: 'phone',
            value: ''
          },
          {
            text: this.$t('AddressBook.fax'),
            type: 'fax',
            value: ''
          },
          {
            text: this.$t('AddressBook.email'),
            type: 'email',
            value: ''
          },
          {
            text: this.$t('AddressBook.contact'),
            type: 'contact',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ],
        fieldsObjSAG: [
          {
            text: this.$t('AddressBook.name'),
            type: 'A',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ],
        fieldsObjTRA: [
          {
            text: this.$t('AddressBook.name'),
            type: 'name',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ],
        fieldsObjDEA: [
          {
            text: this.$t('AddressBook.name'),
            type: 'name',
            value: ''
          },
          {
            text: '',
            type: '',
            value: ''
          }
        ]
      }
    },

  created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false
    this.isScreenSmall = window.innerWidth < 800
    var id = this.companyUID

    this.$bindAsArray('customers', db.ref('database/transporter/' + id + '/carnet'), null, () => {
      this.isLoading = false
    })

    this.$bindAsArray('sageone', db.ref('sageoneid/' + id), null, () => {
      this.filteredSearchMethodSage()
    })

    this.$bindAsArray('dealerTrans', db.ref('database/transporter/' + id + '/customer'), null, () => {
      this.filteredSearchMethodSage()
      this.isLoading = false
    })

    this.$bindAsArray('trans', db.ref('users/transporters/' + id + '/listTrans'))
    this.$bindAsArray('deal', db.ref('users/transporters/' + id + '/listDeal'))
  },

  computed: {
    customerFilledForm: function () {
      if (
        this.customer.name !== '' &&
        this.customer.phone !== '' &&
        this.customer.address !== '' &&
        this.customer.postcode !== '') return true
      else return false
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },
    uid () {
      return this.$store.state.user.uid
    }
  },
  methods: {
    updateFilterResults (sortResults) {
      this.filterResults = sortResults
      this.filterResultsSageOne = sortResults
    },

    setModalTitle (title) {
      this.modalTitle = title
    },

    getAddressData (addressData, placeResultData) {
      this.customer.name = ''
      this.customer.address = ''
      this.customer.postcode = ''
      this.customer.phone = ''
      this.customer.city = ''
      this.customer.province = ''
      this.customer.country = ''
      this.customer.place_id = ''
      this.customer.lat = 0
      this.customer.long = 0

      this.customer.name = placeResultData.name
      this.customer.address = placeResultData.formatted_address.split(',')[0]
      this.customer.postcode = addressData.postal_code
      this.customer.phone = placeResultData.formatted_phone_number
      this.customer.city = addressData.locality
      this.customer.province = addressData.administrative_area_level_1
      this.customer.country = addressData.country
      this.customer.place_id = placeResultData.place_id
      this.customer.lat = addressData.latitude
      this.customer.long = addressData.longitude
    },
    setSage (event) {
      console.log(event)
      if (event.key) {
        this.datalist.name = event.originalVal
        delete event.originalVal
        this.sageCustomer.push(event)
      } else this.datalist.name = event.value
      // this.datalist.key = event.key
      // this.datalist.dealer = event.dealer
      // this.datalist.transporter = event.transporter
    },
    SubmitmodifySage () {
      // console.log('submit')
      this.sageCustomer.forEach((customer) => {
        if (customer.dealer && customer.key) {
          db.ref('users/dealers/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION DEALER SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_DEALER_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION DEALER SAGE LOG =======================
        }
        if (customer.transporter && customer.key) {
          db.ref('users/transporters/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION TRANSPORTER SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_TRANSPORTER_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION TRANSPORTER SAGE LOG =======================
        }
        if (!customer.dealer && !customer.transporter && customer.key) {
          db.ref('database/transporter/' + this.companyUID + '/carnet/' + customer.key + '/sageID').set(this.sageOneChange.target.B)
          // ======================== ADD MODIFICATION SAGE LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_MODIFICATION', 'targetUID': customer.key, 'date': Date.now(), 'targetName': this.sageOneChange.target.A})
          // ======================== ADD MODIFICATION SAGE LOG =======================
        }
      })
      db.ref('sageoneid/' + this.companyUID).child(this.sageOneChange.target['.key']).child('C').set(this.sageCustomer).then(() => {
        this.modifySage = false
      })
    },
    SubmitmodifyTransDealSage () {
      var uid = this.companyUID
      if (this.sageOneChange.type === 'transporter') {
        db.ref('users/transporters').child(this.sageOneChange.target['.key']).update({sageID: this.datalist.key}).then(() => {
          this.modifySageDealTrans = false
        })
        db.ref('users/transporters').child(uid).child('listTrans').child(this.sageOneChange.target['.key']).update({linked: true})
        // ======================== ADD SAGE TRANSPORTER LINK LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_TRANSPORTER_LINK', 'targetUID': this.sageOneChange.target['.key'], 'date': Date.now(), 'targetName': this.sageOneChange.target.name})
        // ======================== ADD SAGE TRANSPORTER LINK LOG =======================
      } else {
        db.ref('users/dealers').child(this.sageOneChange.target['.key']).update({sageID: this.datalist.key}).then(() => {
          this.modifySageDealTrans = false
        })
        db.ref('users/transporters').child(uid).child('listDeal').child(this.sageOneChange.target['.key']).update({linked: true})
        // ======================== ADD SAGE LINK LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'SAGE_LINK', 'targetUID': this.sageOneChange.target['.key'], 'date': Date.now(), 'targetName': this.sageOneChange.target.name})
        // ======================== ADD SAGE LINK LOG =======================
      }
    },
    evaluateFiltering (attr, val) {
      this.fields[attr] = val

      var isAttrDupe = false
      if (val === '') return

      this.searchHistory.find((o, i) => {
        if (o.searchType === attr) {
          var storedDupeTag = this.setSearchedItemTag(attr)
          this.searchHistory[i] = {
            searchType: attr, searchText: val, historyTypeTag: storedDupeTag}
          isAttrDupe = true
          return
        }
      })
      if (!isAttrDupe) {
        this.addSearchedItem(attr, val)
      }
    },
    setSearchedItemTag (attr) {
      var storedTag
      if (attr === 'name') { storedTag = this.$t('AddressBook.name') }
      if (attr === 'phone') { storedTag = this.$t('AddressBook.phone') }
      if (attr === 'email') { storedTag = this.$t('AddressBook.email') }
      if (attr === 'address') { storedTag = this.$t('AddressBook.address') }
      if (attr === 'fax') { storedTag = this.$t('AddressBook.fax') }
      if (attr === 'contact') { storedTag = this.$t('AddressBook.contact') }
      return storedTag
    },
    addSearchedItem (searchedType, searchedText) {
      var storedTag = this.setSearchedItemTag(searchedType)
      this.searchHistory.push({searchType: searchedType, searchText: searchedText, historyTypeTag: storedTag})
    },
    removeSearchedItem (index, attr) {
      this.searchHistory.splice(index, 1)
      this.evaluateFiltering(attr, '')
    },

    filteredSearchMethodSage: _.debounce(function () {
      this.filterResultsSageOne = []
      this.filterResultsSageOne = this.sageone.filter((entry) => {
        // var result = true
        var reg = this.sageOneNameFilter.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        var re = new RegExp(reg, 'i')
        var result = re.test(entry.A)
        // if (result === false) break
        return result
      })
      // this.filterResultsSageOne = this.filterResultsSageOne.concat(this.dealerTrans)
    }, 100),
    addCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(this.customer).then(() => {
        // ======================== ADD CUSTOMER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER LOG =======================
        this.add = !this.add
        this.clear()
      })
    },
    modifyCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/carnet/' + this.key).update(this.customer).then(() => {
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.modify = !this.modify
        this.clear()
      })
    },
    modifying: function (customer) {
      this.modify = true
      for (var attr in this.customer) {
        this.customer[attr] = customer[attr]
        if (customer[attr] === undefined) this.customer[attr] = ''
      }
      this.key = customer['.key']
    },
    modifyingSage: function (customer) {
      this.sageOneChange.target = customer
      this.datalist.name = ''
      this.datalist.key = null
      this.sageCustomer = Object.values(customer.C || {})
      this.modifySage = true
    },
    modifyingTransDealSage (dealerTrans, type) {
      this.sageOneChange.target = dealerTrans
      this.sageOneChange.type = type
      this.datalist.name = ''
      this.datalist.key = null
      this.modifySageDealTrans = true
    },
    clear: function () {
      for (var attr in this.customer) {
        this.customer[attr] = ''
      }
    },
    deleteCustomer: function () {
      db.ref('database/transporter/' + this.companyUID + '/carnet/').child(this.key).remove().then(() => {
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'DELETE_CUSTOMER', 'customerName': this.customer.name, 'date': Date.now()})
        // ======================== ADD CUSTOMER MODIFICATION LOG =======================
        this.modify = !this.modify
        this.clear()
      })
    },

    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  watch: {
    sageone: function () {
      this.filteredSearchMethodSage()
    },
    dealers: function () {
      this.filteredSearchMethodSage()
    },
    transporters: function () {
      this.filteredSearchMethodSage()
    },
    dealerTrans: function () {
      this.filteredSearchMethodSage()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .delete {
    border-radius: 4px;
    cursor: pointer;
  }
  .delete:hover {
    background-color: #666e71;
    transition: all linear 150ms;
  }
  .badge-kne {
    background-color: #2c2d2f;
  }
  p.table-fix-width {
    /*max-width: 15rem;*/
  }
  .table thead th {
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  .current {
    border-left: 3px solid #f7941e;
  }
  .datalist {
    margin-bottom: 0px;
  }
  .linked {
    background-color: #B4EEB4;
  }
  h6 {
    overflow-wrap: break-word;
  }
  .vgaSearch {
    max-width: 97%;
    border: 1px solid;
  }
</style>
